"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskURL = exports.filterByTaskSection = exports.TaskDetails = exports.TASK_SECTION_NAMES = void 0;
const BedroomsPage_1 = __importDefault(require("../view/pages/tasks/bedrooms/BedroomsPage"));
const BathroomsPage_1 = __importDefault(require("../view/pages/tasks/bathrooms/BathroomsPage"));
const AmenitiesPage_1 = __importDefault(require("../view/pages/tasks/amenities/AmenitiesPage"));
const CompositionPage_1 = __importDefault(require("../view/pages/tasks/composition/CompositionPage"));
const LocationPage_1 = __importDefault(require("../view/pages/tasks/location/LocationPage"));
const config_1 = require("../view/pages/tasks/local-licence/config");
const LocalLicencePage_1 = __importDefault(require("../view/pages/tasks/local-licence/LocalLicencePage"));
const ArrivalsAndDeparturesPage_1 = __importDefault(require("../view/pages/tasks/arrivals-and-departures/ArrivalsAndDeparturesPage"));
const HouseRulesPage_1 = __importDefault(require("../view/pages/tasks/rules/HouseRulesPage"));
const InternalNamePage_1 = __importDefault(require("../view/pages/tasks/internal-name/InternalNamePage"));
const TitlePage_1 = __importDefault(require("../view/pages/tasks/title/TitlePage"));
const DescriptionPage_1 = __importDefault(require("../view/pages/tasks/description/DescriptionPage"));
const AvailabilityTaskPage_1 = __importDefault(require("../view/pages/tasks/availability/AvailabilityTaskPage"));
const MarketingChannelsPage_1 = __importDefault(require("../view/pages/tasks/marketing-channels/MarketingChannelsPage"));
const CommissionPage_1 = __importDefault(require("../view/pages/tasks/commission/CommissionPage"));
const TermsAndConditions_1 = __importDefault(require("../view/pages/tasks/terms-and-conditions/TermsAndConditions"));
const CleaningFeePage_1 = __importDefault(require("../view/pages/tasks/cleaning-fee/CleaningFeePage"));
const SecurityDepositPage_1 = __importDefault(require("../view/pages/tasks/security-deposit/SecurityDepositPage"));
const TouristTaxPage_1 = __importDefault(require("../view/pages/tasks/tourist-tax/TouristTaxPage"));
const BookingNoticePage_1 = __importDefault(require("../view/pages/tasks/booking-notice/BookingNoticePage"));
const PersonalDetailsPage_1 = __importDefault(require("../view/pages/tasks/personal-details/PersonalDetailsPage"));
const PhotosPage_1 = __importDefault(require("../view/pages/tasks/photos/PhotosPage"));
const PricingPage_1 = __importDefault(require("../view/pages/tasks/pricing/PricingPage"));
const PromotionsPage_1 = __importDefault(require("../view/pages/tasks/promotions/PromotionsPage"));
const types_1 = require("../entities/fact/types");
const constants_1 = require("./constants");
const types_2 = require("../types");
const capability_1 = require("../util/capability");
const restrictedContent_1 = require("../util/restrictedContent");
const TASK_SECTION_NAMES = (context) => {
    const verb = context.edit ? 'Edit' : 'Add';
    return {
        [constants_1.TaskSections.BEDS_BATHS_AMENITIES]: `${verb} bedrooms, bathrooms and amenities`,
        [constants_1.TaskSections.ARRIVALS_HOUSE_RULES]: `${verb} arrival/departure details and house rules`,
        [constants_1.TaskSections.PRICING_FEES]: `${verb} pricing, fees and tax`,
        [constants_1.TaskSections.PHOTOS_DESCRIPTION_AVAILABILITY]: `${verb} photos, description and set availability`,
        [constants_1.TaskSections.CHANNELS]: 'Choose your channels',
        [constants_1.TaskSections.ACCOUNT]: 'Travelnest account details'
    };
};
exports.TASK_SECTION_NAMES = TASK_SECTION_NAMES;
exports.TaskDetails = {
    [constants_1.Tasks.BEDROOMS]: {
        routeName: 'bedrooms',
        component: BedroomsPage_1.default,
        section: constants_1.TaskSections.BEDS_BATHS_AMENITIES,
        validationRequirements: {
            type: 'property',
            propertyFields: ['beds']
        }
    },
    [constants_1.Tasks.BATHROOMS]: {
        routeName: 'bathrooms',
        component: BathroomsPage_1.default,
        section: constants_1.TaskSections.BEDS_BATHS_AMENITIES,
        validationRequirements: {
            type: 'property',
            propertyFields: ['bathrooms']
        }
    },
    [constants_1.Tasks.AMENITIES_FEATURES]: {
        routeName: 'amenities',
        component: AmenitiesPage_1.default,
        section: constants_1.TaskSections.BEDS_BATHS_AMENITIES,
        validationRequirements: {
            type: 'property',
            propertyFields: ['amenities']
        },
        initReviewRequired: true
    },
    [constants_1.Tasks.PROPERTY_COMPOSITION]: {
        routeName: 'composition',
        component: CompositionPage_1.default,
        section: constants_1.TaskSections.BEDS_BATHS_AMENITIES,
        validationRequirements: {
            type: 'property',
            propertyFields: ['property_size', 'property_type']
        }
    },
    [constants_1.Tasks.LOCATION]: {
        routeName: 'location',
        component: LocationPage_1.default,
        section: constants_1.TaskSections.BEDS_BATHS_AMENITIES,
        initReviewRequired: true,
        validationRequirements: {
            type: 'property',
            propertyFields: ['address1', 'city', 'postcode', 'country_code', 'longitude', 'latitude']
        }
    },
    [constants_1.Tasks.LOCAL_LICENCE]: {
        routeName: 'local-licence',
        component: LocalLicencePage_1.default,
        section: constants_1.TaskSections.BEDS_BATHS_AMENITIES,
        overlay: (_, property) => {
            var _a, _b, _c, _d, _e, _f;
            if (!(Object.keys(config_1.LocalLicenceCountries).includes((_a = property === null || property === void 0 ? void 0 : property.country_code) !== null && _a !== void 0 ? _a : '') ||
                Object.keys(config_1.LocalLicenceOptionalCountries).includes((_b = property === null || property === void 0 ? void 0 : property.country_code) !== null && _b !== void 0 ? _b : ''))) {
                return ({ completion: types_1.TaskCompletionState.HIDDEN });
            }
            if (Object.keys(config_1.LocalLicenceOptionalCountries).includes((_c = property === null || property === void 0 ? void 0 : property.country_code) !== null && _c !== void 0 ? _c : '')) {
                return { completion: types_1.TaskCompletionState.COMPLETE };
            }
            if ((property === null || property === void 0 ? void 0 : property.country_code) === 'ES') {
                if (!!property.local_licence) {
                    const localLicence = property.local_licence;
                    if (!localLicence.is_in_region_requiring_tourist_licence)
                        return ({});
                }
            }
            if ((property === null || property === void 0 ? void 0 : property.country_code) === 'IE') {
                if (!!((_d = property.local_licence) === null || _d === void 0 ? void 0 : _d.tax_id_number) || !!((_e = property.local_licence) === null || _e === void 0 ? void 0 : _e.identification_number)) {
                    return ({});
                }
            }
            return !(((_f = property === null || property === void 0 ? void 0 : property.local_licence) === null || _f === void 0 ? void 0 : _f.number) || '').trim() ? { completion: types_1.TaskCompletionState.REVIEW_REQUIRED } : {};
        },
        validationRequirements: {
            type: 'local_licence',
        }
    },
    [constants_1.Tasks.ARRIVALS_DEPARTURES]: {
        routeName: 'arrivals-and-departures',
        component: ArrivalsAndDeparturesPage_1.default,
        section: constants_1.TaskSections.ARRIVALS_HOUSE_RULES,
        validationRequirements: {
            type: 'property',
            propertyFields: ['check_in', 'check_out']
        }
    },
    [constants_1.Tasks.HOUSE_RULES]: {
        routeName: 'house-rules',
        component: HouseRulesPage_1.default,
        section: constants_1.TaskSections.ARRIVALS_HOUSE_RULES
    },
    [constants_1.Tasks.PRICING]: {
        routeName: 'pricing',
        component: PricingPage_1.default,
        section: constants_1.TaskSections.PRICING_FEES,
        validationRequirements: {
            type: 'pricing'
        },
        hasSubRoutes: true,
        overlay: (capabilities, _, pricing) => {
            if ((0, capability_1.hasCapability)(capabilities, types_2.DashboardCapabilities.DisablePricing))
                return ({ noReadOrEdit: true });
            // check if any of the price periods has a 0
            const hasZeroPrice = ((pricing === null || pricing === void 0 ? void 0 : pricing.filter(period => Object.values(period.prices).includes(0))) || []).length > 0;
            if (hasZeroPrice) {
                return ({ completion: types_1.TaskCompletionState.INPUT_REQUIRED });
            }
            return ({});
        }
    },
    [constants_1.Tasks.PROMOTIONS]: {
        routeName: 'promotions',
        component: PromotionsPage_1.default,
        section: constants_1.TaskSections.PRICING_FEES,
        initReviewRequired: true,
    },
    [constants_1.Tasks.CLEANING_FEE]: {
        routeName: 'cleaning-fee',
        component: CleaningFeePage_1.default,
        section: constants_1.TaskSections.PRICING_FEES
    },
    [constants_1.Tasks.SECURITY_DEPOSIT]: {
        routeName: 'security-deposit',
        component: SecurityDepositPage_1.default,
        section: constants_1.TaskSections.PRICING_FEES,
        validationRequirements: {
            type: 'property',
            propertyFields: ['security_deposit']
        }
    },
    [constants_1.Tasks.TOURIST_TAX]: {
        routeName: 'tourist-tax',
        component: TouristTaxPage_1.default,
        section: constants_1.TaskSections.PRICING_FEES
    },
    [constants_1.Tasks.INTERNAL_NAME]: {
        routeName: 'internal-name',
        component: InternalNamePage_1.default,
        section: constants_1.TaskSections.PHOTOS_DESCRIPTION_AVAILABILITY,
        validationRequirements: {
            type: 'property',
            propertyFields: ['internal_name']
        },
    },
    [constants_1.Tasks.PHOTOS]: {
        routeName: 'photos',
        component: PhotosPage_1.default,
        section: constants_1.TaskSections.PHOTOS_DESCRIPTION_AVAILABILITY,
        validationRequirements: {
            type: 'image'
        }
    },
    [constants_1.Tasks.LISTING_HEADLINE]: {
        routeName: 'headline',
        component: TitlePage_1.default,
        section: constants_1.TaskSections.PHOTOS_DESCRIPTION_AVAILABILITY,
        validationRequirements: {
            type: 'property',
            propertyFields: ['name']
        },
        overlay: (_, property) => {
            var _a;
            // VRBO requires at least 10 chars
            if (((_a = property === null || property === void 0 ? void 0 : property.name) === null || _a === void 0 ? void 0 : _a.length) < 10 || (0, restrictedContent_1.hasCapitalWords)(property === null || property === void 0 ? void 0 : property.name))
                return ({ completion: types_1.TaskCompletionState.INPUT_REQUIRED });
            return {};
        }
    },
    [constants_1.Tasks.LISTING_DESCRIPTION]: {
        routeName: 'description',
        component: DescriptionPage_1.default,
        section: constants_1.TaskSections.PHOTOS_DESCRIPTION_AVAILABILITY,
        initReviewRequired: true,
        validationRequirements: {
            type: 'property',
            propertyFields: ['long_description']
        },
        overlay: (_, property) => ((0, restrictedContent_1.hasBadContent)(property === null || property === void 0 ? void 0 : property.long_description) ? { completion: types_1.TaskCompletionState.INPUT_REQUIRED } : {})
    },
    [constants_1.Tasks.BOOKING_AVAILABILITY]: {
        routeName: 'availability',
        component: AvailabilityTaskPage_1.default,
        section: constants_1.TaskSections.PHOTOS_DESCRIPTION_AVAILABILITY,
        validationRequirements: {
            type: 'availability'
        },
        initReviewRequired: true,
        overlay: (capabilities) => ((0, capability_1.hasCapability)(capabilities, types_2.DashboardCapabilities.DisableAvailability) ? {
            completion: types_1.TaskCompletionState.COMPLETE,
            readOnly: true,
        } : {})
    },
    [constants_1.Tasks.BOOKING_NOTICE]: {
        routeName: 'booking-notice',
        component: BookingNoticePage_1.default,
        section: constants_1.TaskSections.PHOTOS_DESCRIPTION_AVAILABILITY
    },
    [constants_1.Tasks.COMMISSION]: {
        routeName: 'commission',
        component: CommissionPage_1.default,
        section: constants_1.TaskSections.CHANNELS,
        readOnly: true,
        // Hide "account-level" tasks
        overlay: (capabilities, property) => ((0, capability_1.hasCapability)(capabilities, types_2.DashboardCapabilities.Account) ? {} : { completion: types_1.TaskCompletionState.HIDDEN })
    },
    [constants_1.Tasks.CHANNEL_SELECTION]: {
        routeName: 'channel-selection',
        component: MarketingChannelsPage_1.default,
        section: constants_1.TaskSections.CHANNELS,
        validationRequirements: { type: 'channels' },
        // Hide "account-level" tasks
        overlay: (capabilities, property) => ((0, capability_1.hasCapability)(capabilities, types_2.DashboardCapabilities.Account) ? {} : { completion: types_1.TaskCompletionState.HIDDEN })
    },
    [constants_1.Tasks.PERSONAL_DETAILS]: {
        routeName: 'personal-details',
        component: PersonalDetailsPage_1.default,
        section: constants_1.TaskSections.ACCOUNT,
        validationRequirements: {
            type: 'customer',
            customerFields: ['name', 'email', 'phone']
        },
        initReviewRequired: true,
        // Hide "account-level" tasks
        overlay: (capabilities, property) => ((0, capability_1.hasCapability)(capabilities, types_2.DashboardCapabilities.Account) ? {} : { completion: types_1.TaskCompletionState.HIDDEN })
    },
    [constants_1.Tasks.TERMS_CONDITIONS]: {
        routeName: 'terms-and-conditions',
        component: TermsAndConditions_1.default,
        section: constants_1.TaskSections.ACCOUNT,
        validationRequirements: { type: 'terms' },
        // Hide "account-level" tasks
        overlay: (capabilities, property) => ((0, capability_1.hasCapability)(capabilities, types_2.DashboardCapabilities.Account) ? {} : { completion: types_1.TaskCompletionState.HIDDEN })
    }
};
const filterByTaskSection = (section, data) => {
    return Object.keys(data).reduce((all, curr) => {
        if (exports.TaskDetails[curr].section === section) {
            all[curr] = data[curr];
        }
        ;
        return all;
    }, {});
};
exports.filterByTaskSection = filterByTaskSection;
const taskURL = (task) => `/tasks/${task.routeName}`;
exports.taskURL = taskURL;
//# sourceMappingURL=index.js.map